<template>
  <div class="cosnsult-channel-list">
    <mheader
      @toAI="toAI('咨询师推荐列表顶部智能助理')"
      @toOrderList="toOrderList"
      ref="header"
      @initDone="initDone"
    />
    <filterBar
      :value="options"
      :stickOffsetTop="headerHeight"
      :options="selectOption"
      @change="filterBarUpdate"
    />

    <list
      class="list"
      :list="teacherList"
      :page="options.page"
      :size="50"
      @load="getTeacherList"
      ref="list"
    >
      <div
        class="recent-box"
        v-if="isShowRecentTeachers && parseRecentTeachers.length > 0"
      >
        <template v-for="item in parseRecentTeachers">
          <item :key="item.id" :item="item" :include="['_recent_type_']"></item>
        </template>
      </div>

      <template v-for="(item, index) in teacherList">
        <item
          :key="item.id"
          :item="item"
          :class="{
            'hide-bottom-border': index === 9 && isShowAdviser
          }"
        >
        </item>
        <adviser
          :key="'adviser' + item.id"
          v-if="index === 9 && isShowAdviser"
          class="adviser"
          @toAI="toAI('咨询师推荐列表中部智能助理')"
        />
      </template>
      <noTeacherState
        slot="none"
        text="没有找到对应咨询师<br />联系专属顾问极速推荐"
      />
    </list>

    <commonFixedPoints :stopTime="500" v-if="isShowAdviser">
      <defaultAdviserPoint :showDelay="200" />
      <goTopPoint />
    </commonFixedPoints>

    <toOrderBtn v-if="isWebviewMp" />
    <logoutBtn />
  </div>
</template>

<script>
import filterBar from 'app/web/component/consult/listCommon/filterBar.vue'
import dataStore from 'store/consult/expertList'
import listCommon from 'app/web/store/consult/listCommon.js'
import consultPageMixin from 'app/web/mixins/consult/page.js'
import noTeacherState from 'component/consult/noTeacherState.vue'
import adviser from 'app/web/component/consult/listCommon/adviser.vue'
import defaultAdviserPoint from 'component/consult/defaultAdviserPoint'
import commonFixedPoints from 'component/consult/commonFixedPoints'
import list from 'app/web/component/common/list.vue'
import mheader from 'app/web/component/consult/expertList/header.vue'
import toOrderBtn from 'app/web/component/consult/expertList/toOrderBtn.vue'
import logoutBtn from 'app/web/component/consult/expertList/logoutBtn.vue'
import item from 'app/web/component/consult/listCommon/item.vue'

const isRandomSort = options => {
  // eslint-disable-next-line
  const { page, size, ...other } = options
  return !Object.values(other).find(v => !!v)
}

export default {
  dataStore: [listCommon, dataStore],
  mixins: [consultPageMixin],
  components: {
    filterBar,
    item,
    noTeacherState,
    list,
    adviser,
    defaultAdviserPoint,
    commonFixedPoints,
    mheader,
    toOrderBtn,
    logoutBtn
  },
  data() {
    return {
      headerHeight: this.isWebviewMp ? 0 : 40,
      isShowRecentTeachers: true,
      consultUserInfo: null
    }
  },

  preFetch({ store, route }) {
    const { channel_id, cid, coupon_id } = route.query
    const channelId = cid || channel_id || ''
    if (channelId) {
      return Promise.reject({
        code: 301,
        data: {
          url: '/consult/channel?cid=' + channelId
        }
      })
    }

    return store.dispatch('consultListCommon/initData', route).then(() => {
      return store.dispatch('consultListCommon/updateTeacherList', {
        size: 50,
        coupon_id,
        randomSort: isRandomSort(store.state.consultListCommon.options)
      })
    })
  },

  mounted() {
    this.$bridge.isPullRefreshEnable({ enable: 0 })

    this.$store.dispatch('consultList/fetchRecentTeachers')

    this.$watch(
      () => this.options,
      (newVal, oldValue) => {
        /* eslint-disable */
        const {
          page,
          size,
          channel_id,
          randomSort,
          channel_flag,
          ...other
        } = newVal
        /* eslint-disable */
        let isShowRecentTeachers = true
        for (let key in other) {
          if (other[key] !== oldValue[key]) {
            isShowRecentTeachers = false
          }
        }
        this.isShowRecentTeachers = isShowRecentTeachers
      },
      {
        deep: true
      }
    )
  },

  methods: {
    getTeacherList(page, callback) {
      const { coupon_id } = this.$route.query
      const isPreThreeAndRandom = isRandomSort(
        this.$store.state.consultListCommon.options
      )

      this.$store
        .dispatch('consultListCommon/fetchTeacherList', {
          page,
          size: 50,
          randomSort: isPreThreeAndRandom,
          coupon_id
        })
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            callback(data.length < 10)
          }
        })
    },

    filterBarUpdate(options) {
      this.$store.commit('consultListCommon/setOptions', options)
      this.$refs.list.refresh()

      window.history.replaceState({}, 0, this.finalUrl)

      // this.setBrowserShare()
    },

    toAI(event) {
      this.eventStat({
        event: event,
        object: '智能助理'
      })
      this.routerToStaic({
        path: '/consult-assistant'
      })
    },
    initDone() {
      this.headerHeight = this.$refs.header.$el.clientHeight
    }
  },

  computed: {
    selectOption() {
      return this.$store.getters['consultListCommon/parsedSelectOption']
    },
    teacherList() {
      const { teacherList } = this.$store.state.consultListCommon
      if (this.$isServer) {
        return teacherList.slice(0, 10)
      }
      return teacherList
      // 筛选调列表相同
      // const { parseRecentTeachers } = this
      // const ids = parseRecentTeachers.map(v => v.user_id)
      // return teacherList.filter(v => ids.indexOf(v.user_id) === -1)
    },
    parseRecentTeachers() {
      const parseRecentTeachers = this.$store.getters[
        'consultList/parseRecentTeachers'
      ]
      return parseRecentTeachers
    },
    options() {
      return this.$store.state.consultListCommon.options
    },

    finalUrl() {
      const { city, province, tag, channel_id } = this.options
      var valiable = `/consult/list${
        city ? '-' + city : province ? '-' + province : ''
      }${tag ? '-' + tag : ''}${channel_id ? `?cid=${channel_id}` : ''}`
      return valiable
    },

    isShowAdviser() {
      return !this.isWebviewMp
    },

    shareConfig() {
      let data = {
        title: '心理咨询师推荐',
        desc: '为你提供专业、优质、可信赖的心理咨询服务，让改变发生',
        link: this.$mZXSafeOrigin + this.finalUrl,
        imgUrl: `https://ossimg.xinli001.com/20190724/cd2c3853c483ae18128e2358dbf423f2.jpeg`
      }

      if (this.channelInfo) {
        const { page_title, share_description, logo } = this.channelInfo

        data.title = page_title
        data.desc = share_description
        data.imgUrl = logo
      }

      return data
    },

    pageStatProperties() {
      const {
        selectOption: { tags },
        options
      } = this

      const targetTag = tags.find(v => +v.value === options.tag)

      const tagStat = targetTag
        ? {
            分类ID: targetTag.value,
            分类名字: targetTag.name
          }
        : {}

      const { consultUserInfo } = this
      const userStat =
        consultUserInfo &&
        consultUserInfo.user_id &&
        +consultUserInfo.new_consult_visit
          ? { 用户身份: '咨询新来访' }
          : {}
      return {
        ...tagStat,
        ...userStat
      }
    }
  },

  created() {
    if (!this.$isServer) {
      this.fetchPromise = this.$store
        .dispatch('consultList/fetchUserInfo')
        .then(res => {
          if (+res.code === 0) {
            this.consultUserInfo = res.data
          }
        })
    }
  }
}
</script>

<style lang="scss">
.cosnsult-channel-list {
  background: #fff;

  .list {
    min-height: 100vh;
    // padding: 0 30px 0;
  }

  .list-title {
    padding: 0 40px;
    font-size: 36px;
    font-weight: 500;
    color: #21252d;
    line-height: 96px;
  }

  .recent-box {
    margin: 40px 30px;
    // padding: 0 30px;
    box-shadow: 0px 0px 40px 0px #ececec;
    border-radius: 30px;
  }

  .adviser {
    margin: 0 30px;
  }

  .hide-bottom-border::before {
    display: none;
  }
}
</style>
